export default __webpack_public_path__ + "static/media/office1-after2-2048w.d8854430.png";